import { useEffect, useState } from 'react'
import haxios, { getApir } from '../lib/haxios'

// url: url to get, haxios rules, /whatever without domain fetches from apir, full url for elsewhere
// initial: initial data value for before fetch has completed
// method: GET or POST
// body: data for POST body or GET query string
// refetch: interval for automatic refetching in ms

const useApi = ({ url, initial = null, method = 'get', data: body = {}, refetch = null }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isFetching, setIsFetching] = useState(true)
  const [data, setData] = useState(initial)
  const [apirReady, setApirReady] = useState(false)
  
  // Check if apir is ready before making calls
  useEffect(() => {
    const checkApir = async () => {
      try {
        const apir = await getApir()
        if (apir) {
          setApirReady(true)
        }
      } catch (error) {
        // apir not ready yet, will retry
      }
    }
    checkApir()
  }, [])
  
  //console.info(url)
  const loadData = async () => {
    // Don't make API call if URL is null or empty
    if (!url) {
      setIsFetching(false)
      setIsLoading(false)
      return
    }

    // Don't make API call if apir isn't ready yet
    if (!apirReady) {
      // Check again
      try {
        const apir = await getApir()
        if (!apir) {
          return // Still not ready
        }
        setApirReady(true)
      } catch (error) {
        return // apir not ready
      }
    }

    setIsFetching(true)

    try {
      let res
      if (method.toLowerCase() === 'get') {
        res = await haxios.get(url, {
          params: body
        })
      } else if (method.toLowerCase() === 'post') {
        res = await haxios.post(url, body)
      }

      setIsFetching(false)
      setIsLoading(false)
      setData(res)
    } catch (error) {
      setIsFetching(false)
      setIsLoading(false)
      console.error('API call failed:', error)
      // Keep existing data on error, don't reset to initial
    }
  }

  const isAbsoluteURLRegex = /^(?:\w+:)\/\//
  
  useEffect(() => {
    //console.log('loadeffect', body)
    // Only make call if apir is ready OR if URL is absolute (doesn't need apir)
    if (apirReady || (url && isAbsoluteURLRegex.test(url))) {
      loadData()
    }
  }, [JSON.stringify(body), url, apirReady])

  useEffect(() => {
    if (!refetch) return

    const interval = setInterval(() => {
      console.log('interval')
      loadData()
    }, refetch)

    return () => clearInterval(interval)
  }, [refetch])

  return {
    isLoading,
    isFetching,
    data,
    refetch: loadData
  }
}

export default useApi
